module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_flint_sm-156e361d7520828d7a72d2290a60b641.png";